/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SET_LOADING,
  SET_CURRENT_NAVIGATION_TAB,
  GET_GROUP,
  GET_GROUP_SUCCESS,
  GET_GROUP_ERROR,
  GET_GROUP_USAGES,
  GET_GROUP_USAGES_SUCCESS,
  GET_GROUP_USAGES_ERROR,
  DELETE_GROUP,
  DELETE_GROUP_CONFIRM_DELETION,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  CLEAR_GROUP_WAS_DELETED,
  UPDATE_GROUP,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_ERROR,
  CREATE_GROUP,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  UPDATE_GROUP_MEMBER_MESSAGING,
  UPDATE_GROUP_MEMBER_MESSAGING_SUCCESS,
  UPDATE_GROUP_MEMBER_MESSAGING_ERROR,
  GET_GROUP_SOURCES,
  GET_GROUP_SOURCES_SUCCESS,
  GET_GROUP_SOURCES_ERROR,
  SET_GROUP_DETAILS_TAB,
  SET_FORM_CREATE_UPDATE_GROUP,
  SET_FORM_UPDATE_GROUP_MEMBER_MESSAGING,
  SET_GROUP_MEMBERS,
  GET_GROUP_MEMBERS,
  GET_GROUP_MEMBERS_SUCCESS,
  GET_GROUP_MEMBERS_ERROR,
  SET_GROUP_MEMBERS_QUERY,
  SET_SELECTED_GROUP_MEMBERS,
  SET_SELECTED_CONTACT_IDS,
  SET_VISIBLE_MODAL_FORM_NUMBER,
  //   SET_VALUES_FORM_SEND_TEXT,
  //   SEND_TEXT_MESSAGE,
  //   SEND_TEXT_MESSAGE_ERROR,
  //   SEND_TEXT_MESSAGE_SUCCESS,
  SET_VALUES_FORM_ADD_CATEGORY,
  SEND_ADD_CATEGORY,
  SEND_ADD_CATEGORY_ERROR,
  SEND_ADD_CATEGORY_SUCCESS,
  SET_VALUES_FORM_ADD_GROUP_MEMBER,
  SEND_ADD_GROUP_MEMBER,
  SEND_ADD_GROUP_MEMBER_ERROR,
  SEND_ADD_GROUP_MEMBER_SUCCESS,
  SEND_REMOVE_GROUP_MEMBERS,
  SEND_REMOVE_GROUP_MEMBERS_ERROR,
  SEND_REMOVE_GROUP_MEMBERS_SUCCESS,
  GET_FOLLOW_UP_MESSAGES,
  GET_FOLLOW_UP_MESSAGES_SUCCESS,
  GET_FOLLOW_UP_MESSAGES_ERROR,
  GET_CONTACTS_LIST,
  GET_CONTACTS_LIST_SUCCESS,
  GET_CONTACTS_LIST_ERROR,
  REPLACE_SYSTEM_GEN_MESSAGE,
  REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
  REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
  SET_VALUES_WELCOME_MESSAGE,
  SET_UPDATE_UPDATE_GROUP_TYPE_COMPONENTS,
  MODIFY_MEMBERS,
  MODIFY_MEMBERS_SUCCESS,
  MODIFY_MEMBERS_ERROR,
  GET_CUSTOM_FIELDS,
  GET_CUSTOM_FIELDS_SUCCESS,
  GET_CUSTOM_FIELDS_ERROR,
} from 'src/actions/groupDetailsActions';

const initialCurrentNavigationTab = 'details';

const groupSourcesList = {
  data: [],
  loading: false,
};

const formSendText = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const formAddCategory = {
  loading: false,
};

const formAddGroupMember = {
  loading: false,
  member: '',
};

const followUpMessages = {
  followUpMessageList: [],
  loading: false,
};

const welcomeMessage = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const formModifyMembers = {
  loading: false,
};

const groupMembers = {
  members: [],
  membersCount: 0,
  loading: false,
  // CON-1532 — V2 Group Contacts column config (set by GET_GROUP_MEMBERS_SUCCESS).
  columnConfig: null,
  // CON-2026 — activity badges (P1d): the member ids shown as new while
  // this group's page is open, kept so marking seen does not take the
  // highlight away mid-visit.
  activityNewIds: [],
  activityGroupId: null,
  // CON-2036 review — how many members were new when this visit began (see
  // partyGuestsActivityVisitTotal).
  activityVisitTotal: 0,
};

const customFields = {
  customFieldsList: [],
  loading: false,
};

const groupDeletionConfirmation = {
  loading: false,
  isDeletionConfirmationRequired: false,
  groupId: null,
  userMessagingSystem: {},
  userCampaignSettings: [],
  groupAndEventSmartActions: [],
  groupAndEventSettingSmartActions: [],
  orderActions: [],
  groups: [],
  groupTypes: [],
  events: [],
  eventTypes: [],
  keywords: [],
  isGroupUsed: false,
  // CON-1847 — { typeLevel, instances, total } or null when not available
  smartActionsLeftDoingNothing: null,
};

const initialState = {
  group: {},
  selectedGroupMembers: [],
  selectedContactIds: [],
  query: {
    search: '',
    sort: {
      table2: 'contact',
      column1: 'lastName',
      column2: 'firstName',
      direction1: 'asc',
      direction2: 'asc',
    },
    page: 1,
    pageSize: 50,
    count: 0,
  },
  groupWasDeleted: false,
  groupDeletionConfirmation,
  updateGroupTypeComponents: false,
  loading: false,
  loadingGroup: false,
  currentNavigationTab: initialCurrentNavigationTab,
  visibleModalFormNumber: null,
  formAddGroupMember,
  formSendText,
  formModifyMembers,
  formAddCategory,
  formCreateUpdateGroup: {
    hasUpdatedCustomFields: false,
  },
  groupMembers,
  groupSourcesList,
  welcomeMessage,
  followUpMessages,
  customFields,
};

const groupDetailsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING: {
      return produce(state, (draft) => {
        draft.loading = payload;
      });
    }

    case SET_CURRENT_NAVIGATION_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialCurrentNavigationTab;
      });
    }

    case MODIFY_MEMBERS: {
      return produce(state, (draft) => {
        draft.formModifyMembers.loading = true;
      });
    }

    case MODIFY_MEMBERS_SUCCESS:
    case MODIFY_MEMBERS_ERROR: {
      return produce(state, (draft) => {
        draft.formModifyMembers.loading = false;
      });
    }

    case GET_GROUP: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.loadingGroup = true;
      });
    }

    case GET_GROUP_SUCCESS: {
      return produce(state, (draft) => {
        draft.group = payload || {};
        draft.loading = false;
        draft.loadingGroup = false;
      });
    }

    case GET_GROUP_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loadingGroup = false;
      });
    }

    case GET_GROUP_USAGES: {
      return produce(state, (draft) => {
        draft.groupDeletionConfirmation.loading = true;
      });
    }

    case GET_GROUP_USAGES_SUCCESS: {
      return produce(state, (draft) => {
        draft.groupDeletionConfirmation.loading = false;
        draft.groupDeletionConfirmation.groupId = payload?.groupId;
        draft.groupDeletionConfirmation.userMessagingSystem = payload?.userMessagingSystem;
        draft.groupDeletionConfirmation.userCampaignSettings = payload?.userCampaignSettings;
        draft.groupDeletionConfirmation.groupAndEventSmartActions = payload?.groupAndEventSmartActions;
        draft.groupDeletionConfirmation.groupAndEventSettingSmartActions = payload?.groupAndEventSettingSmartActions;
        draft.groupDeletionConfirmation.orderActions = payload?.orderActions;
        draft.groupDeletionConfirmation.groups = payload?.groups;
        draft.groupDeletionConfirmation.groupTypes = payload?.groupTypes;
        draft.groupDeletionConfirmation.events = payload?.events;
        draft.groupDeletionConfirmation.eventTypes = payload?.eventTypes;
        draft.groupDeletionConfirmation.keywords = payload?.keywords;
        draft.groupDeletionConfirmation.isGroupUsed = !!payload?.isGroupUsed;
        draft.groupDeletionConfirmation.smartActionsLeftDoingNothing = payload?.smartActionsLeftDoingNothing || null;
      });
    }

    case GET_GROUP_USAGES_ERROR: {
      return produce(state, (draft) => {
        draft.groupDeletionConfirmation.loading = false;
      });
    }

    case GET_GROUP_SOURCES: {
      return produce(state, (draft) => {
        draft.groupSourcesList.loading = true;
      });
    }

    case GET_GROUP_SOURCES_SUCCESS: {
      return produce(state, (draft) => {
        draft.groupSourcesList.data = payload || [];
        draft.groupSourcesList.loading = false;
      });
    }

    case GET_GROUP_SOURCES_ERROR: {
      return produce(state, (draft) => {
        draft.groupSourcesList = { ...groupSourcesList };
      });
    }

    case DELETE_GROUP: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.groupDeletionConfirmation.loading = true;
      });
    }

    case DELETE_GROUP_CONFIRM_DELETION: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.groupDeletionConfirmation.loading = false;
        draft.groupDeletionConfirmation.isDeletionConfirmationRequired = !!payload?.isDeletionConfirmationRequired;
        draft.groupDeletionConfirmation.groupId = payload?.groupId;
      });
    }

    case DELETE_GROUP_SUCCESS: {
      return produce(state, (draft) => {
        draft.group = payload ? initialState.group : state.group;
        draft.loading = false;
        draft.groupWasDeleted = true;
        draft.groupDeletionConfirmation = initialState.groupDeletionConfirmation;
      });
    }

    case DELETE_GROUP_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.groupDeletionConfirmation.loading = false;
      });
    }

    case CLEAR_GROUP_WAS_DELETED: {
      return produce(state, (draft) => {
        draft.groupWasDeleted = false;
      });
    }

    case CREATE_GROUP:
    case UPDATE_GROUP: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case CREATE_GROUP_SUCCESS:
    case CREATE_GROUP_ERROR:
    case UPDATE_GROUP_SUCCESS:
    case UPDATE_GROUP_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case UPDATE_GROUP_MEMBER_MESSAGING: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_GROUP_MEMBER_MESSAGING_SUCCESS:
    case UPDATE_GROUP_MEMBER_MESSAGING_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SET_GROUP_DETAILS_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialState.currentNavigationTab;
      });
    }

    case SET_FORM_CREATE_UPDATE_GROUP: {
      return produce(state, (draft) => {
        draft.formCreateUpdateGroup = payload ? {
          ...state.formCreateUpdateGroup,
          ...payload,
        } : initialState.formCreateUpdateGroup;
      });
    }

    case SET_GROUP_MEMBERS: {
      return produce(state, (draft) => {
        draft.groupMembers.members = payload || [];
        draft.selectedGroupMembers = [];
        draft.selectedContactIds = [];
      });
    }

    case GET_GROUP_MEMBERS: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.groupMembers.loading = true;
      });
    }

    case GET_GROUP_MEMBERS_SUCCESS: {
      return produce(state, (draft) => {
        draft.groupMembers.members = payload?.members || [];
        draft.groupMembers.membersCount = payload?.total || 0;
        draft.query.count = payload?.total || 0;
        // CON-1532 — V2 Group Contacts column config. V1 ignores it.
        draft.groupMembers.columnConfig = payload?.columnConfig || null;
        draft.loading = false;
        draft.groupMembers.loading = false;
        if (draft.groupMembers.activityGroupId !== (payload?.groupId || null)) {
          draft.groupMembers.activityGroupId = payload?.groupId || null;
          draft.groupMembers.activityNewIds = [];
          draft.groupMembers.activityVisitTotal = 0;
        }
        draft.groupMembers.activityVisitTotal = Math.max(
          draft.groupMembers.activityVisitTotal || 0,
          Number(payload?.activity?.unseenTotal) || 0,
        );
        (payload?.activity?.newIds || []).forEach((memberId) => {
          if (!draft.groupMembers.activityNewIds.includes(memberId)) {
            draft.groupMembers.activityNewIds.push(memberId);
          }
        });

        // CON-1658 — see the matching note in partyDetailsReducer. A refetch
        // normally clears the selection; the one after a bulk modify opts out
        // and INTERSECTS with the rows that came back, so a contact edited
        // out of the active filter does not linger in the bulk bar's count.
        if (payload?.keepSelection) {
          const rows = Array.isArray(payload?.members) ? payload.members : [];
          const liveIds = new Set(rows.map((r) => r?.id));
          const liveContactIds = new Set(rows.map((r) => r?.contactId));
          draft.selectedGroupMembers = (draft.selectedGroupMembers || [])
            .filter((id) => liveIds.has(id));
          draft.selectedContactIds = (draft.selectedContactIds || [])
            .filter((id) => liveContactIds.has(id));
        } else {
          draft.selectedGroupMembers = [];
          draft.selectedContactIds = [];
        }
      });
    }

    case GET_GROUP_MEMBERS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.groupMembers.loading = false;
      });
    }

    case SET_GROUP_MEMBERS_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    case SET_SELECTED_GROUP_MEMBERS: {
      return produce(state, (draft) => {
        draft.selectedGroupMembers = payload || [];
      });
    }

    case SET_SELECTED_CONTACT_IDS: {
      return produce(state, (draft) => {
        draft.selectedContactIds = payload || [];
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER: {
      return produce(state, (draft) => {
        draft.visibleModalFormNumber = payload || null;
      });
    }

    // case SET_VALUES_FORM_SEND_TEXT: {
    //   return produce(state, (draft) => {
    //     draft.formSendText = payload ? {
    //       ...state.formSendText,
    //       ...payload,
    //     } : formSendText;
    //   });
    // }

    // case SEND_TEXT_MESSAGE: {
    //   return produce(state, (draft) => {
    //     draft.formSendText.loading = true;
    //   });
    // }

    // case SEND_TEXT_MESSAGE_SUCCESS:
    // case SEND_TEXT_MESSAGE_ERROR: {
    //   return produce(state, (draft) => {
    //     draft.formSendText.loading = false;
    //   });
    // }

    case SET_VALUES_FORM_ADD_CATEGORY: {
      return produce(state, (draft) => {
        draft.formAddCategory = payload ? {
          ...state.formAddCategory,
          ...payload,
        } : formAddCategory;
      });
    }

    case SEND_ADD_CATEGORY: {
      return produce(state, (draft) => {
        draft.formAddCategory.loading = true;
      });
    }

    case SEND_ADD_CATEGORY_SUCCESS:
    case SEND_ADD_CATEGORY_ERROR: {
      return produce(state, (draft) => {
        draft.formAddCategory.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_GROUP_MEMBER: {
      return produce(state, (draft) => {
        draft.formAddGroupMember = payload ? {
          ...state.formAddGroupMember,
          ...payload,
        } : formAddGroupMember;
      });
    }

    case SEND_ADD_GROUP_MEMBER: {
      return produce(state, (draft) => {
        draft.formAddGroupMember.loading = true;
      });
    }

    case SEND_ADD_GROUP_MEMBER_SUCCESS:
    case SEND_ADD_GROUP_MEMBER_ERROR: {
      return produce(state, (draft) => {
        draft.formAddGroupMember.loading = false;
      });
    }

    case SEND_REMOVE_GROUP_MEMBERS: {
      return produce(state, (draft) => {
        draft.groupMembers.loading = true;
      });
    }

    case SEND_REMOVE_GROUP_MEMBERS_SUCCESS:
    case SEND_REMOVE_GROUP_MEMBERS_ERROR: {
      return produce(state, (draft) => {
        draft.groupMembers.loading = false;
      });
    }

    case GET_FOLLOW_UP_MESSAGES: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = true;
      });
    }

    case GET_FOLLOW_UP_MESSAGES_SUCCESS:
    case GET_FOLLOW_UP_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = false;
        draft.followUpMessages.followUpMessageList = payload ? [
          ...state.followUpMessages.followUpMessageList,
          ...payload,
        ] : followUpMessages.followUpMessageList;
      });
    }

    case GET_CONTACTS_LIST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_CONTACTS_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.contacts = payload || [];
        draft.loading = false;
      });
    }

    case GET_CONTACTS_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE: {
      return produce(state, (draft) => {
        draft.welcomeMessage.loading = true;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS:
    case REPLACE_SYSTEM_GEN_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.welcomeMessage.loading = false;
        draft.welcomeMessage.systemGenMessageReplaced = payload || false;
      });
    }

    case SET_FORM_UPDATE_GROUP_MEMBER_MESSAGING: {
      return produce(state, (draft) => {
        draft.formGroupMemberMessaging = payload ? {
          ...state.formGroupMemberMessaging,
          ...payload,
        } : initialState.formGroupMemberMessaging;
      });
    }

    case SET_VALUES_WELCOME_MESSAGE: {
      return produce(state, (draft) => {
        draft.welcomeMessage = payload ? {
          ...state.welcomeMessage,
          ...payload,
        } : welcomeMessage;
      });
    }

    case SET_UPDATE_UPDATE_GROUP_TYPE_COMPONENTS: {
      return produce(state, (draft) => {
        draft.updateGroupTypeComponents = payload;
      });
    }

    case GET_CUSTOM_FIELDS: {
      return produce(state, (draft) => {
        draft.customFields.loading = true;
      });
    }

    case GET_CUSTOM_FIELDS_SUCCESS:
    case GET_CUSTOM_FIELDS_ERROR: {
      return produce(state, (draft) => {
        draft.customFields.loading = false;
        draft.customFields.customFieldsList = payload?.data
          ? payload.data
          : initialState.customFields.customFieldsList;
      });
    }

    default: {
      return state;
    }
  }
};

export default groupDetailsReducer;
